import {
  type DiscountAvailabilityStrategy,
  firstTableDiscountAvailabilityStrategy,
} from "./discountAvailabilityStrategy";
import isInTime from "../../model/times/isInTime";
import { Time } from "../../model/times/model";
import type {
  DiscountAvailabilityById,
  DiscountAvailabilitySlotType,
} from "../../model/types";

function isAvailable(
  slot: DiscountAvailabilitySlotType,
  timesIsSet: boolean,
  startTime: Time,
  endTime: Time,
  strategy: DiscountAvailabilityStrategy,
  people?: number,
  session?: SessionType,
) {
  if (session && slot.session !== session) {
    return false;
  }

  if (!strategy.includeSlot(slot)) {
    return false;
  }

  if (!strategy.isSlotAvailable(slot, people)) {
    return false;
  }

  if (timesIsSet) {
    return isInTime(slot.time, startTime, endTime);
  }

  return true;
}

export default function hasDiscountAvailability(
  discountAvailabilityById: DiscountAvailabilityById,
  date: string,
  restaurantId: number,
  timesIsSet: boolean,
  startTime: Time,
  endTime: Time,
  people?: number,
  session?: SessionType,
  strategy: DiscountAvailabilityStrategy = firstTableDiscountAvailabilityStrategy,
) {
  const availabilityByDate = discountAvailabilityById[restaurantId];

  if (!availabilityByDate) {
    return false;
  }

  // week view
  if (date === "week") {
    const weekAvailability = Object.values(availabilityByDate);

    const hasWeekAvailability = weekAvailability.some(
      (dayAvailability) =>
        dayAvailability &&
        dayAvailability.some((slot) =>
          isAvailable(
            slot,
            timesIsSet,
            startTime,
            endTime,
            strategy,
            people,
            session,
          ),
        ),
    );

    return hasWeekAvailability;
  }

  // day view
  const dayAvailabilitySlots = availabilityByDate[date];

  if (!dayAvailabilitySlots) {
    return false;
  }

  const hasAvailability = dayAvailabilitySlots.some((slot) =>
    isAvailable(
      slot,
      timesIsSet,
      startTime,
      endTime,
      strategy,
      people,
      session,
    ),
  );

  return hasAvailability;
}
